<template>
  <div>
    <div class="text-left">
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
        <!-- {{getAddr().OrganName}}- -->
        工作任务上报机构:
        <b>{{ getAddr().RangeName }}</b>
      </van-notice-bar>
    </div>
    <!-- 工作流程明细 -->
    <van-cell :border="false" class="text-left">
      <template slot="title">
        <van-row>
          <van-col span="24">
            <span v-if="data.SplitProcessList">
              <span class="text-title">{{ data.ProcessName }}</span>
              <van-tag class="ml-1 mb-1" size="medium" mark type="warning">{{
                data.ProcessTypeName
              }}</van-tag>
            </span>
          </van-col>
        </van-row>
      </template>
      <template slot="label">
        <!-- <p>{{data.ProcessStatusText}}</p> -->
        <label>{{ data.Memo }}</label>
        <br />
        <label v-if="data.BeginTime && data.EndTime">{{
          data.BeginTime + " - " + data.EndTime
        }}</label>
      </template>
    </van-cell>
    <!-- 继承其他工作任务 -->
    <template v-if="data.PlugJson">
      <div
        v-if="
          data.PlugJson.PlugID == 'dutyuser' ||
          data.PlugJson.PlugID == 'dutyperson'
        "
      >
        <van-divider>{{
          data.PlugJson.PlugID == "dutyuser"
            ? "继承其他工作任务保密室值班人员"
            : data.PlugJson.PlugID == "dutyperson"
            ? "继承其他工作任务考务值班人员"
            : ""
        }}</van-divider>
        <inherit @isUpdate="refreshProcess" :data="params"></inherit>
      </div>
    </template>
    <!-- 工作状态上报 -->
    <template v-if="data.PlugJson">
      <van-divider>工作状态上报</van-divider>
      <status v-if="data.PlugJson.PlugBody.IsStatus" :data="params"></status>
      <memo v-if="data.PlugJson.PlugBody.IsMemo" :data="params"></memo>
      <upload v-if="data.PlugJson.PlugBody.IsUpload" :data="params"></upload>
    </template>
    <!-- 加载工作环节插件内容 -->
    <component
      v-if="data.PlugJson && inheritState"
      :is="data.PlugJson.PlugID"
      :SplitProcessID="data.SplitProcessID"
      :ProcessData="data"
      :ProcessRefresh="refreshProcess"
      :completeBtnAttribute="completeBtnAttribute"
    ></component>
    <!-- 当前用户需上报的子任务 -->
    <template
      v-if="data.PeerWorkProcessList && data.PeerWorkProcessList.length > 0"
    >
      <van-cell-group title="工作任务子项" class="text-left">
        <van-cell
          v-for="(item, index) in data.PeerWorkProcessList"
          :key="index"
          title="单元格"
        >
          <template slot="title">{{ item.ProcessName }}</template>
          <template slot="default">
            <van-button
              v-if="item.ProcessStatus == 1"
              type="default"
              size="mini"
              >已上报完成</van-button
            >
            <van-button
              v-else
              type="primary"
              size="mini"
              @click="quickCompletBtn(item.SplitProcessID)"
              >快速上报完成</van-button
            >
          </template>
          <template slot="label">{{
            "当前状态" + item.ProcessStatusName
          }}</template>
        </van-cell>
      </van-cell-group>
    </template>
    <!-- 其他用户需上报的子任务 -->
    <template v-if="data.SubWorkProcessList">
      <van-cell-group class="text-left">
        <van-cell v-for="(item, index) in data.SubWorkProcessList" :key="index">
          <template slot="title">{{ item.ProcessName }}</template>
          <template slot="default">
            <van-button
              type="primary"
              size="mini"
              @click="querySubPlitProcessDetailBtn(item.ProcessID)"
              >{{
                "进度 " + item.FinishedNum + " / " + item.AllNum
              }}</van-button
            >
          </template>
          <template slot="label">
            {{ "未上报" + item.NotReportNum }}
            {{ "已完成" + item.FinishedNum }}
            {{ "未完成" + item.UnFinishedNum }}
            {{ "异常" + item.AbnormalNum }}
          </template>
        </van-cell>
      </van-cell-group>
    </template>
    <!-- 底部导航栏上报按钮 -->
    <van-tabbar :placeholder="true">
      <van-button
        hairline
        type="info"
        :disabled="completeBtnAttribute.disabled"
        class="w-100"
        size="large"
        @click="completeBtn"
        >{{
          completeBtnAttribute.disabled && completeBtnAttribute.tips != ""
            ? completeBtnAttribute.tips
            : completeBtnAttribute.text
        }}</van-button
      >
    </van-tabbar>
    <!-- 加载数据时显示遮罩层 -->
    <van-overlay :show="overlayshow">
      <div class="wrapper">
        <van-loading color="#1989fa">数据加载中...</van-loading>
      </div>
    </van-overlay>
    <!-- 弹出层显示子任务上报情况 -->
    <van-popup
      v-model="sheet1"
      round
      closeable
      position="bottom"
      class="popup-l2"
    >
      <van-nav-bar :title="'工作任务上报情况'" left-text="列表" />
      <van-cell-group>
        <van-cell
          v-for="(item, index) in subSplitProcessDetail.SubProcessDetal"
          :key="index"
          class="text-left"
        >
          <template slot="title">{{ item.RangeName }}</template>
          <template slot="label">{{ item.ProcessStatusName }}</template>
        </van-cell>
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
var requireComponents = {};
const fieldsComponents = require.context(
  "@/exam-plugin/process/fields/",
  true,
  /\.vue/
);
fieldsComponents.keys().forEach(element => {
  // 组件实例
  const reqCom = fieldsComponents(element);
  // 截取路径作为组件名
  const reqComName = element.split("/")[1];
  // 截取组件去扩展名后, 添加到组件对象
  requireComponents[reqComName.split(".")[0]] = reqCom.default || reqCom;
});
const plugComponents = require.context(
  "@/exam-plugin/process/components/",
  true,
  /\.vue/
);
plugComponents.keys().forEach(element => {
  // 组件实例
  const reqCom = plugComponents(element);
  // 截取路径作为组件名
  const reqComName = element.split("/")[1];
  // 截取组件去扩展名后, 添加到组件对象
  requireComponents[reqComName.split(".")[0]] = reqCom.default || reqCom;
});
export default {
  name: "process",
  data () {
    return {
      inheritState: false,
      data: {},
      overlayshow: true, //遮罩层
      params: {
        //提交工作任务状态参数
        WorkID: this.getWork().WorkID,
        SplitProcessID: this.$route.params.id,
        OrganID: this.getAddr().OrganID,
        RoleID: this.getAddr().RoleID,
        Status: 1,
        Memo: "",
        PlugID: this.$route.params.PlugID

      },
      completeBtnAttribute: {
        //工作任务提交按钮属性
        text: "上报工作任务情况",
        disabled: false,
        tips: "", //提示
        tipsShow: false
      },
      subSplitProcessDetail: [],
      sheet1: false
    };
  },
  components: requireComponents,
  methods: {
    refreshProcess () {
      this.inheritState = false
      //获取考试工作任务列表
      this.apiWorkProcessDetailGet(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.$route.params.id
        },
        this,
        res => {
          if (res.code == 20000) {
            this.inheritState = true
            this.data = res.data;
          } else {
            this.$toast(res.message);
          }
        }
      );
    }, //提交工作环节状态上报,上报完成后刷新data状态
    quickCompletBtn (SplitProcessID) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否要快速上报子任务完成状态？"
        })
        .then(() => {
          //上报通用工作环节状态
          this.apiGeneralReportPut(
            {
              //提交工作任务状态参数
              WorkID: this.getWork().WorkID,
              SplitProcessID: SplitProcessID,
              OrganID: this.getAddr().OrganID,
              RoleID: this.getAddr().RoleID,
              Status: 1,
              Memo: ""
            },
            this,
            res => {
              this.$toast(res.message);
              if (res.code == 20000) {
                this.refreshProcess();
                this.getGeneralData();
              } else {
                this.$toast(res.message);
              }
            }
          );
        });
    },
    querySubPlitProcessDetailBtn (ProcessID) {
      this.subProcessDetailGet(
        {
          WorkID: this.getWork().WorkID,
          ProcessID: ProcessID
        },
        this,
        res => {
          this.sheet1 = true;
          this.subSplitProcessDetail = res.data;
        }
      );
    },
    async completeBtn () {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定工作任务已完成并提交工作任务？"
        })
        .then(async () => {
          // on confirm 点击确认判断工作任务插件要求验证当前状态是否可以执行上报操作
          // IsMemo 是否需要填写文字： 0不需要，1允许，2强制
          if (this.data.PlugJson.PlugBody.IsMemo == 2) {
            if (this.params.Memo == "") {
              this.$toast("工作任务需要填写说明后才可以上报完成状态");
              return;
            }
          }
          // IsUpload 是否需要上传文件： 0不需要，1允许，2强制
          if (this.data.PlugJson.PlugBody.IsUpLoad == 2) {
            await this.apiGeneralFileGet(
              {
                WorkID: this.getWork().WorkID,
                SplitProcessID: this.$route.params.id
              },
              this,
              res => {
                if (res.code == 20000) {
                  if (!(res.data.length > 0)) {
                    //需要上传文件后上报
                  }
                } else {
                  this.$toast(res.message);
                }
              }
            );
          }

          this.completeHandle();
        })
        .catch(e => {
          // on cancel
          // eslint-disable-next-line no-console
          console.log("触发异常", e);
        });
    },
    completeHandle () {
      //上报通用工作环节状态
      this.apiGeneralReportPut(this.params, this, res => {
        this.$toast(res.message);
        if (res.code == 20000) {
          //this.getGeneralData();
          this.$router.push({ name: "WorkReport" });
        } else {
          this.$toast(res.message);
        }
      });
    },
    getGeneralData () {
      this.apiGeneralReportGet(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.$route.params.id
        },
        this,
        res => {
          if (res.code == 20000) {
            this.overlayshow = false;
            this.params.Memo = res.data.Memo;
            if (res.data.Status == 1) {
              this.completeBtnAttribute.disabled = true;
              this.completeBtnAttribute.text = "任务已完成";
            }
          } else {
            this.$toast(res.message);
          }
        }
      );
    }
  },
  created () {
    this.params.WorkID = this.getWork().WorkID;
    this.params.SplitProcessID = this.$route.params.id;
    this.refreshProcess();
    this.getGeneralData();
  },
  mounted () { }
};
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>